var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"samples-traceability"},[_c('div',{staticClass:"p-10 ml-13"},[_c('router-view')],1)])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }